// src/hooks/useBranding.js
import { useState, useEffect, createContext, useContext } from "react";
import { fetchBranding } from "../firebase/services";

const BrandContext = createContext(null);

const DEFAULT = {
  brandName:    "Nilam Synthetics",
  tagline:      "Elegance Woven in Every Thread",
  logoUrl:      null,
  whatsapp:     "",
  phone:        "",
  address:      "Ahmedabad, Gujarat, India",
  primaryColor: "#F47B20",
};

export function BrandProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT);
  const [ready,    setReady]    = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const data = await fetchBranding();
      if (cancelled) return;
      setBranding({ ...DEFAULT, ...data });
      setReady(true);
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <BrandContext.Provider value={{ branding, ready }}>
      {children}
    </BrandContext.Provider>
  );
}

export const useBranding = () => useContext(BrandContext);
